import React, { useEffect, useState } from 'react';
import './App.css'; // Import the default styles

const Players = () => {
    const [players, setPlayers] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const ratingsResponse = await fetch('http://localhost:3001/api/players');
                if (!ratingsResponse.ok) {
                    throw new Error(`HTTP error! Status: ${ratingsResponse.status}`);
                }

                const data = await ratingsResponse.json();

                const positionFactor = {
                    "QB": 0.4,
                    "TE": 1.75,
                    "RB": 1.1
                };

                const conferenceFactor = {
                    'ACC': 5.0,
                    'American Athletic': -4.9,
                    'Big 12': 5.3,
                    'Big Ten': 8,
                    'Conference USA': -12.5,
                    'FBS Independents': 1.17,
                    'Mid-American': -9.6,
                    'Mountain West': -7.3,
                    'Pac-12': -2.7,
                    'SEC': 14.8,
                    'Sun Belt': -5.41,
                };

                // Adjust PPA based on conference
                const adjustedData = data.map(player => {
                    const positionMultiplier = positionFactor[player.position] || 1.0;
                    const conferenceMultiplier = conferenceFactor[player.conference] || 1.0;
                    return {
                        ...player,
                        adjustedPPA: (player.averagePPA?.all + player.totalPPA?.all) * positionMultiplier + conferenceMultiplier
                    };
                });
                
                // Sort by averagePPA.all in descending order
                const sortedData = adjustedData.sort((a, b) => (b.adjustedPPA || 0) - (a.adjustedPPA || 0));

                setPlayers(sortedData);
            } catch (error) {
                console.error('Error fetching player data:', error);
            }
        };

        fetchData();
    }, []);

    const getPositionRanks = (players) => {
        const positionRanks = {};
        return players.map((player) => {
            const position = player.position;
            if (!positionRanks[position]) {
                positionRanks[position] = 1; // Start rank at 1 for each position
            } else {
                positionRanks[position]++;
            }
            return { ...player, positionRank: positionRanks[position] };
        });
    };

    const rankedPlayers = getPositionRanks(players);

    return (
        <div className="page">
            <div className="leaderboard">
            <h2>Players Stats (Sorted by Avg PPA High → Low)</h2>
            <table>
                <thead>
                        <tr>
                            <th>Rk</th>
                        <th>Player</th>
                        <th>Position</th>
                        <th>Tm</th>
                        <th>PPA</th>
                        <th>Conf</th>
                    </tr>
                </thead>
                <tbody>
                        {rankedPlayers.map((player, index) => (
                        <tr key={player.id}>
                            <td>{index + 1}</td>
                            <td>{player.name}</td>
                            <td>{player.position} #{player.positionRank}</td>
                            <td>{player.team}</td>
                                <td>{player.adjustedPPA?.toFixed(2)}</td>
                            <td>{player.conference}</td>
                        </tr>
                    ))}
                </tbody>
                </table>
            </div>
        </div>
    );
};

export default Players;
